import {ACTION_TYPES} from "../consts";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {LOCAL_STORAGE_KEYS} from "../consts";
import {ThemesToggleClickEvent} from "../models/events/themes-toggle-click-event";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {THEME} from "../app/consts";

export class ToggleSetDarkThemeHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.toggleSetDarkTheme;
  localStorageUtils: LocalStorageUtils;
  analyticsService: AnalyticsService;

  static injectables = [AnalyticsService, LocalStorageUtils];

  constructor(analyticsService: AnalyticsService, localStorageUtils: LocalStorageUtils) {
    super(analyticsService);

    this.eventType = ThemesToggleClickEvent;
    this.analyticsService = analyticsService;
    this.localStorageUtils = localStorageUtils;
  }

  onInitialized(controller: BaseController) {
    super.onInitialized(controller);

    this.appStore.state.updateTheme(this.localStorageUtils.get(LOCAL_STORAGE_KEYS.theme));
  }

  action(params) {
    this.appStore.state.updateTheme(params.isActive ? THEME.DARK : THEME.LIGHT);

    this.localStorageUtils.set(LOCAL_STORAGE_KEYS.theme, this.appStore.state.theme);
    document.documentElement.setAttribute("data-theme",  this.appStore.state.theme);

    super.action(params)
  }
}
